import { isValid, format, intervalToDuration } from 'date-fns';
import { pickBy } from 'lodash';
import { DateYMDString } from '@lt/api/dist/types/date';
import { formatDate } from '@lt/components/utils/date';

export const convertDateToServerFormat = (date: Date): DateYMDString => {
  const mm = date.getMonth() + 1;
  const dd = date.getDate();
  const yyyy = date.getFullYear();

  return [yyyy, mm, dd].join('-') as DateYMDString;
};

/**
 * Вырезаем таймзону, чтобы показать местное время
 * @param {string} date 2018-12-26T10:00:00.000+03:00
 * @returns {string} 2018-12-26T10:00:00
 */
export const getDateWithoutTimezone = (date: string) => {
  const [dateWithoutTimezone] = date.split('.');
  const parseDate = new Date(dateWithoutTimezone);

  const isValidDate = isValid(parseDate);
  return isValidDate ? dateWithoutTimezone : date;
};

/**
 * Возвращает время из даты безопасно, с фолбеком на текст
 * @param {string} date
 * @param {string} invalidText
 * @returns {string} HH:mm | Неизвестно
 */
export const getHoursSafe = (date: string, invalidText = 'Неизвестно') => {
  const dateString = getDateWithoutTimezone(date);

  if (!dateString) return invalidText;

  const parseDate = new Date(dateString);
  return format(parseDate, 'HH:mm');
};

/**
 * Возвращает время в формате 1 д 2 ч 25 мин
 * @param {number} value seconds
 * @param {string} minuteSuffix суфикс
 * @returns {string}
 */
export const getFormattedDuration = (value: number, minuteSuffix = 'мин'): string => {
  const prepareDuration = intervalToDuration({ start: 0, end: value * 1000 });
  const duration = pickBy(prepareDuration);

  const { days, hours, minutes } = duration;

  const formattedDays = days ? `${days} д ` : '';
  const formattedHours = hours ? `${hours} ч ` : '';
  const formattedMinutes = minutes ? `${minutes} ${minuteSuffix}` : '';

  return [formattedDays, formattedHours, formattedMinutes].join('');
};

export const SERVER_DATE_FORMAT = 'yyyy-MM-dd';
export const CLIENT_DATE_FORMAT = 'dd.MM.yyyy';

/**
 * Возвращает дату в формате 2019-03-16
 * @param {Date} date
 * @returns {string}
 */
export const formatServerDate = (date: Date | null) => formatDate(date, SERVER_DATE_FORMAT);

export const getMidnightFromString = (date: string | Date | number): number =>
  new Date(date).setHours(0, 0, 0, 0);

/**
 * Конвертирует серверную дату YYYY-MM-DD в клиентскую DD.MM.YYYY
 * @param {string | Date} string YYYY-MM-DD
 * @returns {string} DD.MM.YYYY
 */
export const convertServerDateToClientDate = (string: string | Date | null) =>
  formatDate(string, CLIENT_DATE_FORMAT);
